import React from 'react'
import Route from 'route-parser'
import { useSelector } from 'react-redux'
import { URL_DATA } from 'constants/urls'
import { dismissPopover } from 'services/OverlayService'
import selectAolName from 'redux/selectors/selectAolName'
import TealToolTip from 'components/TealToolTip'
import Icon from 'components/shared/Icon'

const dataRoute = (props) => new Route(URL_DATA).reverse(props)

const DownloadButton = ({ precedentId, isLogged, setSignUpModalIsOpen }) => {
  const handleOnClick = (e) => {
    dismissPopover(e.target)
    if (!isLogged) {
      e.preventDefault()
      e.stopPropagation()
      setSignUpModalIsOpen(true)
    }
  }
  const aol = useSelector(selectAolName)

  return (
    <TealToolTip title='Download' placement='bottom'>
      <div onClick={handleOnClick}>
        <a href={isLogged ? dataRoute({ aol, id: precedentId }) : null}>
          <Icon name='icon-download' className='w6' />
        </a>
      </div>
    </TealToolTip>
  )
}

export default DownloadButton
